export enum TypeProjet {
  PremierAcheteur = 'MPM',
  ExperimenteRemplacer = 'PME_REMPLACER',
  ExperimenteSecondaire = 'PME_SECONDAIRE'
}
